import { ActionPermissionsObject, PermissionActionType } from "common/interfaces";

function hasPermission(actionPermissions, action) {
    const entry = actionPermissions?.[action];
    return Boolean(entry?.use ?? entry?.[PermissionActionType.USE]);
}

function getImageSourcePermissions(actionPermissions) {
    return {
        canGenerate: hasPermission(actionPermissions, ActionPermissionsObject.GENERATIVE_AI) &&
            hasPermission(actionPermissions, ActionPermissionsObject.GENERATIVE_AI_IMAGES),
        canUseTeamAssets: hasPermission(actionPermissions, ActionPermissionsObject.SHARED_RESOURCES),
        canUseWebSearch: hasPermission(actionPermissions, ActionPermissionsObject.WEB_IMAGES),
        canUseStockImages: hasPermission(actionPermissions, ActionPermissionsObject.STOCK_LIBRARIES)
    };
}

function resolveImageSource(imageSource, actionPermissions, excludedSources = []) {
    const { canGenerate, canUseTeamAssets, canUseWebSearch, canUseStockImages } = getImageSourcePermissions(actionPermissions);
    const requested = imageSource || "ai";
    const allowed = {
        ai: canGenerate && !excludedSources.includes("ai"),
        team: canUseTeamAssets && !excludedSources.includes("team"),
        web: canUseWebSearch && !excludedSources.includes("web"),
        stock: canUseStockImages && !excludedSources.includes("stock"),
        none: !excludedSources.includes("none")
    };
    if (allowed[requested]) {
        return requested;
    }
    const fallbackOrder = ["ai", "team", "web", "stock", "none"];
    return fallbackOrder.find(candidate => allowed[candidate]) || "none";
}

export default resolveImageSource;
